export default "__VITE_ASSET__2f165bd9__"